import theme from '../../../../../js/shared/new-theme';

export const componentWrapper = `
  position: relative;
`;

export const wrapper = `
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1400;
  max-width: 100%;
  width: 100%;
  height: 100vh;
  border: 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  border-radius: 0;

  &.open {
    opacity: 1;
    visibility: visible;
  }

  @media screen and (min-width: 768px) {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 19;
    transition: all 0.2s;
    visibility: visible;
    width: 100%;
    max-width: 450px;
    height: 0;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.2s;
    border-radius: 8px;

    &.open {
      position: absolute;
      height: auto;
    }
  }
`;

export const liveSearch = `
  width: 100%;
  max-height: 100%;
  overflow-y: auto;

  .inputMobile {
    padding: 32px 24px 24px;
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    max-width: 450px;
    max-height: 338px;

    .inputMobile {
      display: none;
    }
  }
`;

export const select = `
  border: 0;
  width: auto;
  height: auto;
  font-family: ${theme.font.family};
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1abc9c;

  -webkit-appearance: none !important;
  background-color: transparent;
  cursor: pointer;

  display: flex;
  align-items: center;

  @media screen and (min-width: 1024px) {
    font-size: 16px;
  }

  i {
    font-size: 10px;
    margin-left: 11px;
  }
`;

export const resultsWrapper = `
  padding: 0 12px 12px;
`;

export const popularTitle = `
  padding: 24px 12px 16px;

  .placeholder {
    font-weight: 600;
    color: #3f3f3f;
  }
`;

export const result = `
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  box-sizing: border-box;
  border-radius: 4px;
  color: #3f3f3f;
  font-weight: 500;
  background-color: #fff;
  line-height: 1.43;
  letter-spacing: normal;
  cursor: pointer;
  transition: background 0.2s;
  overflow: hidden;
  flex-wrap: no-wrap;
  padding: 6px 12px;

  @media screen and (max-width: 767px) {
    margin-bottom: 12px;
    i + div {
      margin-left: 12px;
    }
  }

  span {
    font-weight: 600;
    color: #1abc9c;
  }

  &:hover {
    color: #1abc9c;
    background-color: rgba(26, 188, 156, 0.1);

    div {
      color: #1abc9c;
      + div {
        color: #3f3f3f;
      }
    }

    i {
      color: inherit;
    }
  }

  &:first-of-type {
    margin-top: 8px;
  }
`;

export const iata = `
  order: 2;
  font-weight: 500;
  color: #74757e;

  @media screen and (min-width: 768px) {
    text-align: center;
    min-width: 35px;
    order: 1;
    font-weight: 600;
    margin-right: 12px;
  }
`;

export const city = `
  color: #3f3f3f;
  font-weight: 500;
  order: 1;

  @media screen and (min-width: 768px) {
    order: 2;
  }
`;

export const flexWrapper = `
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const deactivate = `
  position: fixed;
  top: 8px;
  right: 0;
  border: 0;
  padding: 16px;
  background: transparent;
  color: #3f3f3f;
  appearance: none;
  z-index: 1400;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;
